"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionBuilder = void 0;
class PromotionBuilder {
    build(apiPromotion, catalogs) {
        return {
            startDateTime: apiPromotion.validFor.startDateTime,
            endDateTime: apiPromotion.validFor.endDateTime,
            id: apiPromotion.id,
            description: apiPromotion.description,
            code: apiPromotion.pattern[0].name,
            actions: PromotionBuilder.fromApiPromotion(catalogs, apiPromotion.pattern[0].action),
            aboveTheLine: PromotionBuilder.getAboveTheLine(apiPromotion),
            hiddenPlans: PromotionBuilder.getHiddenPlans(apiPromotion),
            conditions: PromotionBuilder.getConditions(apiPromotion)
        };
    }
    static fromApiPromotion(catalogs, apiActions) {
        if (!apiActions)
            return [];
        let actions = [];
        actions = apiActions.map((action) => {
            return {
                name: action.actionType,
                value: action.actionValue,
                actionCatalogObject: PromotionBuilder.fromCatalogProduct(PromotionBuilder.getCatalogProduct(action.actionObjectId, catalogs, 'promotion')),
                duration: action.actionDuration || 0,
                applicableTo: action.actionApplicableTo,
                applicableWhen: action.applicableWhen,
                discountDescription: action.discountDescription || ''
            };
        });
        return actions;
    }
    static fromCatalogProduct(product) {
        return {
            id: (product === null || product === void 0 ? void 0 : product.id) || '',
            name: (product === null || product === void 0 ? void 0 : product.name) || '',
            description: (product === null || product === void 0 ? void 0 : product.description) || '',
            isSellable: (product === null || product === void 0 ? void 0 : product.isSellable) || false,
            symbillId: (product === null || product === void 0 ? void 0 : product.symbillId) || null,
            price: (product === null || product === void 0 ? void 0 : product.price) || 0,
            term: (product === null || product === void 0 ? void 0 : product.term) || null,
            code: (product === null || product === void 0 ? void 0 : product.code) || null,
        };
    }
    static getCatalogProduct(productId, catalogs, type) {
        const catalog = catalogs.find(catalog => catalog.type === type);
        if (catalog)
            return catalog.products.find(product => product.id === productId);
        else
            return undefined;
    }
    static getHiddenPlans(apiPromotion) {
        const hiddenPlans = [];
        const criteriaGroup = apiPromotion.pattern[0].criteriaGroup.find(c => c.groupName === 'hidden plan as condition');
        if (criteriaGroup) {
            for (const criteria of criteriaGroup.criteria) {
                hiddenPlans.push(criteria.criteriaValue);
            }
        }
        return hiddenPlans;
    }
    static getAboveTheLine(apiPromotion) {
        const criteriaGroup = apiPromotion.pattern[0].criteriaGroup.find(c => c.groupName === 'display as condition');
        if (criteriaGroup) {
            return Boolean(criteriaGroup.criteria[0].criteriaValue);
        }
        return false;
    }
    static getConditions(apiPromotion) {
        const contractCriteria = apiPromotion.pattern[0].criteriaGroup.find(c => c.groupName === 'contract length as condition');
        const planCriteria = apiPromotion.pattern[0].criteriaGroup.find(c => c.groupName === 'plan speed as condition');
        let condition = '';
        if (contractCriteria) {
            condition = condition + 'Minimum ' + contractCriteria.criteria[0].criteriaValue + ' month contract. ';
        }
        if (planCriteria) {
            condition = condition + 'Minimum ' + planCriteria.criteria[0].criteriaValue + 'Mbps plan.';
        }
        return condition;
    }
}
exports.PromotionBuilder = PromotionBuilder;
//# sourceMappingURL=promotionBuilder.js.map